<template>
    <v-app-bar app>
        <v-toolbar-title class="headline text-uppercase" @click="routeToCard">
            <span>HigherLower</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text @click="this.routeToHighscore">Highscores</v-btn>
    </v-app-bar>
</template>

<script>
    export default {
        name: 'Navbar',
        methods: {
            routeToHighscore() {
                this.$router.push('/highscore');
            },

            routeToCard() {
                this.$router.push('/');
            }
        }
    };
</script>

<style scoped>

</style>